import {
	GET_TRACKER_LAST_UPDATE,
	GET_TRACKER_TABLE,
	TOGGLE_IMPORT_MODAL_VISIBILITY
} from '../actions/TrackerActions.js';

const initialState = {
	trackerLastUpdate: '',
	trackerTableData: [],
	importModalVisibility: false
};

const trackerReducer = (state = initialState, action) => {
	switch (action.type) {
					case GET_TRACKER_LAST_UPDATE: {
						return {
							...state,
							trackerLastUpdate: action.trackerLastUpdate
						};
					}
					case GET_TRACKER_TABLE: {
						return {
							...state,
							trackerTableData: action.trackerTableData
						};
					}
					case TOGGLE_IMPORT_MODAL_VISIBILITY: {
						return {
							...state,
							importModalVisibility: action.importModalVisibility
						};
					}
					default: {
						return state;
					}
	}
};

export default trackerReducer;
